import { render, staticRenderFns } from "./MceAccordion.vue?vue&type=template&id=fb1d556a&scoped=true&"
import script from "./MceAccordion.vue?vue&type=script&lang=js&"
export * from "./MceAccordion.vue?vue&type=script&lang=js&"
import style0 from "./MceAccordion.vue?vue&type=style&index=0&id=fb1d556a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1d556a",
  null
  
)

export default component.exports